import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./LimitelessUtility.css";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const LimitelessUtility = () => {
  const { currentLang } = useContext(LanguageContext);
  const [utility, setUtility] = useState(null);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchUtility = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/LimitlessUtility?lang=${currentLang}`
        );
        setUtility(res.data);
      } catch (error) {
        console.error("Error fetching Limitless Utility section:", error);
      }
    };

    fetchUtility();
  }, [currentLang]);

  if (!utility) return null;

  return (
    <section id="limitless-utility" className="limitelessUtility">
      {/* === Section Text === */}
      <div className="limitelessUtility-content">
        <h1 className="limitelessUtility-title">{utility.title}</h1>
        <p className="limitelessUtility-description">
          {utility.description}
        </p>
      </div>

      {/* === Stats === */}
      <div className="limitelessUtility-stats">
        <div className="stat-box">
          <div className="stat-line"></div>
          <h3>{utility.stat1Label}</h3>
          <p>{utility.stat1Value}</p>
        </div>

        <div className="stat-box">
          <div className="stat-line"></div>
          <h3>{utility.stat2Label}</h3>
          <p>{utility.stat2Value}</p>
        </div>

        <div className="stat-box">
          <div className="stat-line"></div>
          <h3>{utility.stat3Label}</h3>
          <p>{utility.stat3Value}</p>
        </div>

        <div className="stat-box">
          <div className="stat-line"></div>
          <h3>{utility.stat4Label}</h3>
          <p>{utility.stat4Value}</p>
        </div>
      </div>

      {/* === Image === */}
      <div className="limitelessUtility-image">
        <img
          src={resolveUrl(utility.imageUrl)}
          alt="Limitless Utility"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default LimitelessUtility;
